export default __webpack_public_path__ + "static/media/Ellipse 1.2f0b4c73.svg";